import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  FormButtonStyled,
  FormButtonStyledLeftIcon,
  LabelStyled,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import CustomRadioButton from "../../../../components/common/radioButtons/CustomRadio";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import ValidationErrorText from "../../../../components/common/inputFields/ValidationErrorText";
import { useLocation } from "react-router-dom";
import { formateAmounts } from "../../../../utils";
import { Download } from "../../../../components/styled/AllImages";
import { useUser } from "../../../../context/userContext";
import AuthApi from "../../../../services/api/authApi";
import { useDebounce } from "../../../../hooks/useDebounce";

const SignupStep2 = ({
  planInfo,
  handleSteps,
  paymentMethod,
  bankInfo,
  totalAmount,
  setTotalAmount,
  setPaymentMethod,
  setValue,
  addLicenseFrm,
  register,
  watch,
  errors,
  setPromoDiscount,
  promoDiscount,
}) => {
  const numOfLicenses = watch("number_of_licenses") || 0;
  const promoCode = watch("promotion_code") || "";
  const deboundedPromoCode = useDebounce(promoCode, 500);
  const [promoError, setPromoError] = useState("");
  const { t } = useTranslation();
  const { user } = useUser();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const payment_method = searchParams.get("payment_method");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPaymentMethod(value);
    setValue(name, value);
  };

  const checkPromoCode = async (codeVal) => {
    try {
      const { data, message, code } = await AuthApi.checkPromoCode(codeVal);
      if (code === 200 && data?.discount) {
        setPromoDiscount(parseFloat(data?.discount));
        setPromoError(null);
      }
      if (code === 204) {
        setPromoDiscount(0);
        setPromoError({
          promotion_code: {
            type: "required",
            message: "invalid_promo_code",
          },
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (deboundedPromoCode) checkPromoCode(deboundedPromoCode);
    else setPromoDiscount(0);
  }, [deboundedPromoCode]);
  useEffect(() => {
    // if (planInfo?.amount) {
    //   const baseCost = parseFloat(planInfo?.amount);
    //   const discount = baseCost * (parseFloat(promoDiscount) / 100);
    //   const vatAmount = bankInfo?.vat?.vat
    //     ? (parseFloat(bankInfo?.vat?.vat) / 100) * baseCost - (discount || 0)
    //     : 0;
    //   const totalAmount =
    //     parseFloat(baseCost - discount || 0) + parseFloat(vatAmount.toFixed(2));

    //   setTotalAmount(totalAmount);
    //   // setTotalAmount(totalAmount.toFixed(2));
    // }

    const amountRaw = parseFloat(planInfo?.amount);
    if (Number.isNaN(amountRaw) || amountRaw <= 0) {
      setTotalAmount(0);
      return;
    }

    // parse promoDiscount (percent). Allow '10' or '10.5' or number. default 0
    const promoPercent = Number(promoDiscount);
    const promoPct = Number.isFinite(promoPercent) ? promoPercent : 0;

    const baseCost = amountRaw;
    const discount = (promoPct / 100) * baseCost;

    // taxable base after discount (never negative)
    const taxableBase = Math.max(0, baseCost - discount);

    // parse VAT percentage from bankInfo.vat.vat (defensive)
    const vatPercentRaw = bankInfo?.vat?.vat;
    const vatPercent = Number(vatPercentRaw);
    const vatRate = Number.isFinite(vatPercent) ? vatPercent / 100 : 0;

    const vatAmount = vatRate * taxableBase;

    // round to 2 decimals (keep as number)
    const totalAmount = Math.round((taxableBase + vatAmount) * 100) / 100;

    setTotalAmount(totalAmount);
  }, [promoDiscount]);

  return (
    <Step2Wrapper>
      <Box>
        <ValidatedInput
          name="promotion_code"
          label={"promo_code_optional"}
          type="input"
          fieldType="text"
          placeholder={"promo_code"}
          className={"mb-3 combined flex-wrap p-0"}
          bg="var(--white)"
          value={promoCode}
          outline={true}
          register={register}
          errors={promoError}
          validationRules={{
            required: false,
          }}
        />
        {/* <Box>
          <ValidatedInput
            name="number_of_licenses"
            label={"num_of_licenses"}
            type="input"
            fieldType="number"
            placeholder={"numOfLicensePlaceholder"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          />
        </Box> */}

        <Box className="total-wrapper">
          <Box className="total-content-wrapper">
            <TextStyled
              size="18px"
              color="var(--themeColor)"
              className="align-items-sm-baseline"
              weight="700"
            >
              {t("total")}: {formateAmounts(totalAmount)}{" "}
              {user?.organization?.currency?.stringCode || t("sar")}
              <SpanStyled size="14px">
                &nbsp; &nbsp;
                {t("inc_tax")}
              </SpanStyled>
            </TextStyled>
            {/* <FormButtonStyledLeftIcon
              height={"30px"}
              size={"14px"}
              icon={Download}
              label={t("download_invoice")}
              color="var(--white)"
              bg="var(--themeColor2)"
              className="w-100 mb-3"
              clName=""
              type="button"
              // isLoading={loading}
            /> */}
          </Box>
        </Box>
        {/* <Box className="mb-3">
          <Box>
            <LabelStyled
              size="16px"
              // weight="bold"
              color="var(--text)"
              className="mb-1"
            >
              {t("choose_payment_method")}
            </LabelStyled>
          </Box>
          <Box className="d-flex gap-3 w-50">
            <CustomRadioButton
              name="payment_method"
              label={t("card")}
              value={"card"}
              checked={paymentMethod === "card"}
              disabled={payment_method && payment_method !== "card"}
              register={register}
              validationRules={{
                required: true,
                onChange: handleChange,
              }}
            />
          </Box>
          {errors?.payment_method?.type === "required" && (
            <ValidationErrorText
              text={
                t(errors?.payment_method?.message) ||
                `${t("payment_method")} ${t("isRequired")}.`
              }
            />
          )}
        </Box> */}
      </Box>
      <FormButtonStyled
        label={t("next")}
        color="var(--white)"
        bg="var(--themeColor)"
        className="w-100"
        clName="w-100 my-4"
        type="button"
        disabled={!paymentMethod}
        onClick={handleSteps}
      />
    </Step2Wrapper>
  );
};

export default SignupStep2;

const Step2Wrapper = styled.div`
  .total-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    margin-block: 20px;
  }
  .total-content-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    @media (max-width: 900px) {
      flex-direction: column;
      align-items: flex-start;
    }
    @media (max-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
    @media (max-width: 395px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
